import { render, staticRenderFns } from "./TripFlights.vue?vue&type=template&id=1b454fe7&"
import script from "./TripFlights.vue?vue&type=script&lang=js&"
export * from "./TripFlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports